import React, { createContext, useContext, useState, useCallback } from 'react';

const SettingsDialogContext = createContext();

export const useSettingsDialog = () => useContext(SettingsDialogContext);

export const SettingsDialogProvider = ({ children }) => {
    const [open, setOpen] = useState(false);

    const openDialog = useCallback(() => setOpen(true), []);
    const closeDialog = useCallback(() => setOpen(false), []);

    return (
        <SettingsDialogContext.Provider value={{ open, openDialog, closeDialog }}>
            {children}
        </SettingsDialogContext.Provider>
    );
}; 